/** Presentation only. Durable receipts keep their stable operational IDs. */
export function assistantPublicCopy(text:string):string{
 return text
  // Older saved messages predate conversational completion receipts. Keep
  // their verified delivery/review facts, without exposing ledger prose.
  .replace(/\b(\d+) of (\d+) requested images delivered\. (?:No images are missing\.|\d+ images? (?:was|were) not delivered\.) (\d+) passed quality review; (\d+) needs? review; (\d+) (?:is|are) not quality-verified\./g,
   (original,deliveredText,requestedText,passedText,reviewText,unknownText)=>{
    const [delivered,requested,passed,review,unknown]=[deliveredText,requestedText,passedText,reviewText,unknownText].map(Number);
    if(delivered>requested||passed+review+unknown!==delivered)return original;
    const opening=!delivered?'I couldn’t finish the image generation.':delivered<requested?
     `I’ve added ${delivered} of the ${requested} ads to your canvas. ${requested-delivered===1?'One couldn’t':`${requested-delivered} couldn’t`} finish.`:
     delivered===1?'Your ad is ready on the canvas.':`Your ${delivered} ads are ready on the canvas.`;
    return [opening,review?`${review===1?'One needs':`${review} need`} a closer look before you use ${review===1?'it':'them'}.`:'',unknown?`The quality check couldn’t finish for ${unknown===1?'one image':`${unknown} images`}.`:''].filter(Boolean).join(' ');
   })
  .replace(/\bqueued as job\s*#?\d+\b/gi,'in progress')
  .replace(/\bJob\s*#?\d+\s+is queued[;.]?/gi,'The work is in progress.')
  .replace(/\b(?:as|under) job\s*#?\d+\b/gi,'')
  .replace(/\bjob(?:\s+ID)?\s*[:#]?\s*\d+\b/gi,'this request');
}
